export default __webpack_public_path__ + "static/media/undo.46488384.svg";